import { styled, Tooltip, useTheme } from '@mui/material'
import { Typography, TypographyProps } from 'ComponentLibrary'
import useElementOverflow from 'ComponentLibrary/src/hooks/useElementOverflow'

type TextWithEllipsisProps = {
    children: React.ReactNode
    tooltipText: string
    typographyProps?: TypographyProps
}

export function TextWithEllipsis({ children, tooltipText, typographyProps }: TextWithEllipsisProps) {
    const { isOverflowing, elementRef } = useElementOverflow()
    const theme = useTheme()
    return (
        <Tooltip title={isOverflowing ? tooltipText : ''}>
            <Text {...typographyProps} ref={elementRef} color={typographyProps?.color ?? theme.palette.customtext.black100}>
                {children}
            </Text>
        </Tooltip>
    )
}

const Text = styled(Typography)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: fit-content;
`
